import { render } from "./vacations_table.vue?vue&type=template&id=30f0d1d8"
import script from "./vacations_table.vue?vue&type=script&lang=js"
export * from "./vacations_table.vue?vue&type=script&lang=js"

import "./vacations_table.vue?vue&type=style&index=0&id=30f0d1d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__